export default __webpack_public_path__ + "static/media/living2.056d1d64.jpg";